module.exports = __webpack_public_path__ + "static/media/mailbox.2dd6a80d.svg";